import 'react-app-polyfill/ie9';
import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import 'instantsearch.css/themes/reset.css';
import 'instantsearch.css/themes/algolia.css';
import App from './App';


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
